const isValidCallbackImage = ({ block }: any) => {
    const {
        data: { image },
    } = block;
    return {
        isValid: Boolean(image.trim()),
        error: (
            <div>
                {/* <b>Validation Error: </b>
                <span
                    style={{
                        color: "red",
                        textDecoration: "underline",
                        fontStyle: "italic",
                    }}
                >
                    Image block cannot be Empty
                </span> */}
            </div>
        ),
    };
};

export default isValidCallbackImage;
